(function () {
  'use strict';

  function initBrandMegaMenu(menu) {
    if (!menu || menu.dataset.brandMegaMenuReady === 'true') return;
    menu.dataset.brandMegaMenuReady = 'true';

    var toggles = menu.querySelectorAll('.brand-megamenu__toggle');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        var panelId = toggle.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);

        toggles.forEach(function (otherToggle) {
          if (otherToggle === toggle) return;
          otherToggle.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(otherToggle.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
        });

        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-brand-megamenu]').forEach(initBrandMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
